import { render } from "./OrderMain.vue?vue&type=template&id=3b38c335&scoped=true"
import script from "./OrderMain.vue?vue&type=script&lang=js"
export * from "./OrderMain.vue?vue&type=script&lang=js"

import "./OrderMain.vue?vue&type=style&index=0&id=3b38c335&scoped=true&lang=css"
import "./OrderMain.vue?vue&type=style&index=1&id=3b38c335&lang=css"

import exportComponent from "D:\\code\\miao_up_up_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b38c335"]])

export default __exports__